/**
 * Runtime platform detection.
 *
 * Capacitor sets `window.Capacitor` when the bundle runs inside the native
 * iOS/Android shell. We use that to hide App-Store-forbidden purchase
 * surfaces (SaaS subscription checkout) from the mobile build WITHOUT
 * removing them from the web app.
 *
 * IMPORTANT: this ONLY gates the ClientDesk VA SaaS subscription CTAs
 * (Change plan / Upgrade / Subscribe / Stripe checkout for `plans`).
 * Client-invoice payments — where a client pays a VA for real-world
 * services rendered outside the app — are exempt from IAP under both
 * Apple 3.1.3(e) and Google's physical-services carve-out, and stay
 * fully visible on every platform.
 */
export function isNativeApp() {
  if (typeof window === "undefined") return false;
  const cap = window.Capacitor;
  if (cap && typeof cap.isNativePlatform === "function") {
    try { return cap.isNativePlatform(); } catch (_) { return false; }
  }
  return !!(cap && cap.platform && cap.platform !== "web");
}
